export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/page-previous.091c4669-e23700.svg";